module.exports = __webpack_public_path__ + "img/card_informe_seguimiento_documentos.399b0501.svg";